import * as React from 'react';
import {useState} from "react";
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import cx from 'classnames';

const SalesListFilter = (props) => {
  const {
    statusHelper,
    filter,
    onStatusChange,
    onFilter,
  } = props;
  const [queryFilter, setQueryFilter] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  let options;
  if (filter.status) {
    options = [{ value: null, label: 'Remove Filter' }].concat(statusHelper.options);
  } else {
    options = statusHelper.options;
  }

  const handleStatusChange = (option) => {
    onStatusChange(option.value)
  }

  const handleQueryChange = (e) => {
    setQueryFilter(e.target.value)
  }

  const onFilterSubmit = (e) => {
    e.preventDefault();
    onFilter(queryFilter);
  }

  const onExport = (e) => {
    e.preventDefault();

    if (startDate && endDate) {
      props.onExport(startDate, endDate);
    }
  };

  const btnClass = cx('btn btn--disabled btn--tert btn--lg inview-button', {
    'btn--disabled--active': startDate && endDate && startDate <= endDate,
  });

  return (
    <>
      {props.onExport && <>
        <div className="filter--inview filter--inview--pb-8">
          <div className="input--date filter--inview__item">
            <DatePicker
              onChange={setStartDate}
              selected={startDate}
              popperPlacement="bottom-end"
              placeholderText="Start Date"
              withPortal
            />
          </div>
          <div className="input--date filter--inview__item">
            <DatePicker
              onChange={setEndDate}
              selected={endDate}
              popperPlacement="bottom-end"
              placeholderText="End Date"
              withPortal
            />
          </div>
        </div>
        <div className="filter--inview filter--inview--under-portal">
          <a href="#" className={btnClass} onClick={onExport}>Export</a>
        </div>
      </>}
      <div className="filter--inview filter--inview--under-portal">
        <form onSubmit={onFilterSubmit} className="filter--inview__item">
          <div className="input--search input--ti">
            <a onClick={onFilterSubmit} href="javascript:void(null)" className="input__icon input--search__btn">
              <span className="i i-search" />
            </a>
            <input
              type="text"
              placeholder="Search"
              onChange={handleQueryChange}
              defaultValue={filter && filter.q}
            />
          </div>
        </form>
        <ReactSelect
          name="status"
          label="Status"
          className="filter--drop filter--inview__item"
          placeholder="Filter Status"
          classNamePrefix="filter--drop"
          value={statusHelper.getSelectValue(filter.status)}
          options={options}
          onChange={handleStatusChange}
          onInputChange={statusHelper.search}
          isLoading={!!statusHelper.isLoading}
        />
      </div>
    </>
  )
}

export default SalesListFilter
